clearDebounce